import { Inject, Injectable } from '@angular/core';
import { DefaultEnvironment, ENVIRONMENT_TOKEN } from '../models/config.model';

@Injectable({
	providedIn: 'root',
})
export class ConfigService {
	constructor(@Inject(ENVIRONMENT_TOKEN) public environment: DefaultEnvironment) {}
}
